import { object } from "yup";
import config from "../config";
import { authHeader } from "../helpers";

const getAllResources = (query) => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  if (query !== undefined) {
    return fetch(
      `${config.authApiUrl}/resource?${new URLSearchParams(query)}`,
      requestOptions
    ).then(handleResponse);
  } else {
    return fetch(`${config.authApiUrl}/resource`, requestOptions).then(
      handleResponse
    );
  }
};

const createUser = (userData) => {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(userData),
  };

  return fetch(`${config.authApiUrl}/resource/user-add`, requestOptions).then(
    handleResponse
  );
};

const createResource = (resourceData) => {
  if (resourceData?.skills && resourceData?.skills.length > 0 && typeof resourceData?.skills === "object") {
    resourceData.skills = resourceData?.skills.join(",")
  }else{
    resourceData.skills = resourceData?.skills
  }
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(resourceData),
  };

  return fetch(`${config.authApiUrl}/resource`, requestOptions).then(
    handleResponse
  );
};

const updateResource = (resourceData, id) => {
  if (resourceData?.skills && resourceData?.skills.length > 0 && typeof resourceData?.skills === "object") {
    resourceData.skills = resourceData?.skills.join(",")
  }
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(resourceData),
  };

  return fetch(`${config.authApiUrl}/resource/${id}?platform=ats`, requestOptions).then(
    handleResponse
  );
};

const resourceStatusChange = (resourceData, id) => {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(resourceData),
  };

  return fetch(`${config.authApiUrl}/resource/status/${id}?platform=ats`, requestOptions).then(
    handleResponse
  );
};

const getEnum = () => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${config.authApiUrl}/resource/enum`, requestOptions).then(
    handleResponse
  );
};

const handleResponse = (response) => {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      const error = (data && data.message) || response.statusText;
      if(response.status == 401){
        localStorage.clear()
        window.location.pathname = '/'
      }
      return Promise.reject(error);
    }
    return data;
  });
};

export const resourceService = {
  getAllResources,
  getEnum,
  createUser,
  createResource,
  updateResource,
  resourceStatusChange

};
